import {TransactionInfo, UseSendTransaction} from './types';
import {redirect} from '@utils';

const useSendTransaction: UseSendTransaction = ({ setError }) => {
  const handleSendTransaction = async (data?: TransactionInfo) => {
    if (!data) { return false; }

    if (!data.pageUrl) {
      window.history.back();
      return false;
    }

    try {
      const dataParams = Object.entries(data.data);

      const params = dataParams.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`).join('&');

      const url = `${data.pageUrl}${params ? `?${params}` : ''}`;
      redirect(url);

      return true;
    } catch (e) {
      setError(String(e));

      return false;
    }
  };

  return { onSendTransaction: handleSendTransaction };
};

export default useSendTransaction;
